<template>
    <div :class="{ 'mb-4': smallText.length === 0 && !noMargin }">
        <label v-if="!noLabel || label.length !== 0" :for="`formFile-${name}`" class="form-label">
            <strong>
                {{ label}}
            </strong>
        </label>
        <div style="position: relative; display: inline-block; width: 100%;">
            <input
                type="file"
                class="form-control"
                :id="`formFile-${name}`"
                ref="fileUploadInput"
                @change="processFiles"
                :multiple="multiple"
                style="padding-right: 2rem;"
            >
            <button
                v-if="fileInternalSignatures.length > 0"
                type="button"
                @click="clearFiles"
                style="position: absolute; right: 0.5rem; top: 50%; transform: translateY(-50%); border: none; background: transparent; font-size: 1.2rem; cursor: pointer; z-index: 2;"
                aria-label="Clear files"
            >
                &times;
            </button>
        </div>
        <input type="hidden" :name="name" :value="fileInternalSignatures.join(',')">
        <p v-if="smallText.length > 0" class="mb-0">
            <small>
                {{ smallText }}
            </small>
        </p>
    </div>
</template>

<script setup>

import axios from 'axios';
import Swal from "sweetalert2";
import { ref } from 'vue';

const props = defineProps({
    label: {
        type: String,
        required: false,
        default: ''
    },
    name: {
        type: String,
        required: false,
        default: () => 'file_internal_signature'
    },
    fileUploadRoute: {
        type: String,
        required: true,
    },
    noMargin: {
        type: Boolean,
        default: false
    },
    noLabel: {
        type: Boolean,
        default: false
    },
    smallText: {
        type: String,
        required: false,
        default: ''
    },
    multiple: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['file-uploaded']);

const fileInternalSignatures = ref([]);

const fileUploadInput = ref(null);

const processFiles = () => {
    fileInternalSignatures.value = [];
    for (let file of fileUploadInput.value.files) {
        processFile(file);
    }
    emit('file-uploaded', fileInternalSignatures.value);
}

const clearFiles = () => {
    fileInternalSignatures.value = [];
    fileUploadInput.value.value = '';
    emit('file-uploaded', fileInternalSignatures.value);
}

defineExpose({
    reset: () => {
        fileInternalSignatures.value = [];
        fileUploadInput.value.value = '';
        emit('file-uploaded', fileInternalSignatures.value);
    }
});

const processFile = async (file) => {

    let uploadDetails;

    try {
        uploadDetails = await axios.post(
            props.fileUploadRoute,
            {
                name: file.name,
                size: file.size,
            }
        ).then(({ data }) => data);
    } catch (error) {
        let status = 'Unknown';
        if (error.response) {
            if (error.response.data && error.response.data.errors) {
                status = error.response.data.errors[0].join(', ');
            } else {
                status = error.response.status;
            }
        }

        Swal.fire({
            icon: 'error',
            title: 'Could not upload file ' + file.name,
            text: 'System error: ' + status,
        });

        // abort upload
        return;
    }

    let data = new FormData();
    for (let key in uploadDetails.inputs) {
        data.append(key, uploadDetails.inputs[key]);
    }
    data.append('key', uploadDetails.destination)
    data.append('file', file);

    let success = false;

    await axios.post(
        uploadDetails.action,
        data,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }
    ).then(() => {
        success = true;
    }).catch((error) => {
        let status = 'Unknown';
        if (error.response) {
            status = error.response.status;
        }
        Swal.fire({
            icon: 'error',
            title: 'Could not upload file ' + file.name,
            text: 'System error: ' + status,
        });
    });
    fileInternalSignatures.value.push(uploadDetails.internalSignature);
}

</script>
